import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  direction: "rtl",
  palette: {
    mode: "dark",
    primary: {
      main: "#4B4590",
    },
    secondary: {
      main: "#F5A623",
    },
    background: {
      default: "#0B0B0B",
      paper: "#1A1A1A",
    },
    text: {
      primary: "#F3F3F3",
      secondary: "#9E9E9E",
    },
    action: {
      disabled: "#666666",
      disabledBackground: "#2a2a2a",
    },
    ...{
      white: {
        main: "#fff",
      },
    },
  },
  typography: {
    fontFamily: "vaziriFont",
    h1: { fontSize: "2.5rem", fontWeight: 700, color: "#ffff" },
    h2: { fontSize: "2rem", fontWeight: 600, color: "#ffff" },
    h6: {
      fontSize: "18px",
      fontWeight: 600,
      color: "#ffff",
    },
    body1: { fontSize: "1rem", color: "#ffff" },
    button: { textTransform: "none", fontWeight: 500, color: "#ffff" },
    subtitle1: { fontSize: "32px", color: "#fff", fontWeight: "Bold" },
  },

  shape: {
    borderRadius: 12,
  },
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          "& > :not(style) ~ :not(style)": {
            marginLeft: "0 !important",
            marginTop: "0 !important",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: "8px 16px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: "#fff",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: "#fff",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          right: "16px",
          left: "auto",
          transformOrigin: "top right",
          textAlign: "right",
          direction: "rtl",
          border: "8px !important",
          background: "#1C1C1D !important",
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        input: {
          textAlign: "right",
        },
      },
    },
  },
});

export default theme;
